import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const trackingCodeMutations: UpdatesConfig['Mutation'] = {
  trackingCodeCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('trackingCodes', cache);
  },
};

export default trackingCodeMutations;
